import { RouteEditTab } from "../RouteEditTab";
import { ProjectState } from "../../ViewModel/ProjectState";

type Props = {
  selectedRouteTab: RouteEditTab;
  projectState: ProjectState | undefined;
};
export const isRouteTabFtlAndProjectInSandbox = ({
  selectedRouteTab,
  projectState,
}: Props): boolean => {
  return selectedRouteTab === RouteEditTab.Ftl && projectState === ProjectState.Sandbox;
};
